import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

// Chat, Flow Builder, and the Students pages had no crash containment at all —
// one unguarded property access (a malformed AI decision record, a welcome
// dispatch missing its template key, etc.) blanked the entire route with no
// recovery path. This mirrors the boundary already used for the student portal.
export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('route_render_failed', {
      errorName: error?.name || 'Error',
      message: String(error?.message || 'Unknown render error').slice(0, 240),
      componentStack: String(info?.componentStack || '').slice(0, 1200)
    });
  }

  componentDidUpdate(prevProps) {
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <Box sx={{ py: 6, display: 'flex', justifyContent: 'center' }}>
        <Paper variant="outlined" sx={{ p: 3, maxWidth: 520 }}>
          <Typography variant="h6" fontWeight={800}>This page could not be displayed</Typography>
          <Typography color="text.secondary" sx={{ my: 1.5 }}>
            Something on this page failed to render. Your session is still active — retry, or go back to the dashboard.
          </Typography>
          <Stack direction="row" spacing={1}>
            <Button variant="contained" onClick={() => this.setState({ failed: false })}>Retry</Button>
            <Button onClick={() => { window.location.href = '/dashboard'; }}>Dashboard</Button>
          </Stack>
        </Paper>
      </Box>
    );
  }
}
